import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { SiteConfigContext } from '@bingads-webui-campaign-react/smart-page-context';
import {
  getImageUrlById,
} from '@bingads-webui-campaign-react/smart-component-util';

import { SmartImageView } from './smart-image-view';
import { getResizedImageUrl } from './components/image-resize';

export const SmartImageConnector = ({
  imageId,
  src,
  resizeWidth,
  ...rest
}) => {
  const { siteConfig } = useContext(SiteConfigContext);
  const internalUrl = getImageUrlById(siteConfig, imageId);
  const url = getResizedImageUrl(internalUrl, resizeWidth) || src;

  return (
    url
      ? <SmartImageView src={url} {...rest} />
      : null
  );
};

SmartImageConnector.propTypes = {
  // below two are mutually exclusive
  imageId: PropTypes.string,
  src: PropTypes.string,
  resizeWidth: PropTypes.number,
};

SmartImageConnector.defaultProps = {
  imageId: undefined,
  src: undefined,
  resizeWidth: undefined,
};
